export const interpolate1d = (x: number[], y: number[], xi: number) => {
  if (x.length !== y.length) {
    throw new Error('x and y arrays must have the same length.');
  }

  const n = x.length;
  if (n === 0) {
    throw new Error('arrays should not be empty.');
  }

  // Ensure time array is sorted
  const sortedIdx = x.map((_, i) => i).sort((i, j) => x[i] - x[j]);
  x = sortedIdx.map((i) => x[i]);
  y = sortedIdx.map((i) => y[i]);

  // xi < X[0] or xi > x[x.length-1]
  if (xi < x[0]) return y[0];
  if (xi > x[n - 1]) return y[n - 1];

  // Exact match?
  for (let i = 0; i < n; i++) {
    if (x[i] === xi) return y[i];
  }

  // Find interval [i, i+1] such that x[i] < xi < x[i+1]
  for (let i = 0; i < n - 1; i++) {
    const x0 = x[i];
    const x1 = x[i + 1];

    if (xi > x0 && xi < x1) {
      const v0 = y[i];
      const v1 = y[i + 1];

      // Compute normalized interpolation factor
      const xfactor = (xi - x0) / (x1 - x0);

      return v0 + xfactor * (v1 - v0);
    }
  }
  return 0;
};
